<template>
  <div>
    <Head title="Tambah User" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/users">User</Link>
      <span class="font-medium text-indigo-400">/</span> Tambah
    </h1>
    <div class="w-full overflow-hidden bg-white rounded-md shadow">
      <form @submit.prevent="store">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <text-input v-model="form.fullname" :error="form.errors.fullname" class="w-full pb-8 pr-6 lg:w-1/2" label="Nama Lengkap" />
          <text-input v-model="form.username" :error="form.errors.username" class="w-full pb-8 pr-6 lg:w-1/2" label="User ID" />
          <text-input v-model="form.password" :error="form.errors.password" class="w-full pb-8 pr-6 lg:w-1/2" type="password" autocomplete="new-password" label="Password" />
          <div class="w-full pb-8 pr-6 lg:w-1/2">
            <label for="roles" class="form-label">Role</label>
            <v-select v-model="form.roles" :close-on-select="false" :deselect-from-dropdown="true" multiple :options="roles" :reduce="role => role.id" label="name" placeholder="Pilih Role User" />
          </div>
          <file-input v-model="form.photo" :error="form.errors.photo" class="w-full pb-8 pr-6 lg:w-1/2" type="file" accept="image/*" label="Photo" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 border-t border-gray-100 bg-gray-50">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            <font-awesome-icon icon="fas fa-floppy-disk" class="mr-2" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    roles: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        fullname: '',
        username: '',
        password: '',
        roles: [],
        photo: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/users')
    },
  },
}
</script>
<style scoped>
:deep() {
  --vs-actions-padding: 15px 6px 10px 3px;
  --vs-selected-bg: #2980b9;
  --vs-selected-color: #ecf0f1;
  --vs-controls-color: #ecf0f1;

  --vs-dropdown-option--active-bg: #2980b9;
  --vs-dropdown-option--active-color: #ecf0f1;

  --vs-dropdown-option--deselect-bg: #9b59b6;
  --vs-dropdown-option--deselect-color: #ecf0f1;
}
</style>
